module.exports = __webpack_public_path__ + "media/svg-new/022-right-rose-cfaf85e1.svg";